import { Button } from '@hub/button';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardButton = _ref => {
  let {
    children,
    onClick,
    variant = 'solid'
  } = _ref;
  return /*#__PURE__*/_jsx(Button, {
    colorScheme: "surfacePrimaryWithText",
    sx: {
      paddingX: 'spacing-sm',
      paddingY: 'spacing-md',
      textTransform: 'uppercase',
      width: '100%'
    },
    variant: variant,
    onClick: onClick,
    "data-id": "standard-button_index_StandardButton_Button",
    children: children
  });
};